import {NgModule} from 'ng-metadata/core';
import {PrmNewspapersHome} from './newspapersHome.directive';
import {PrmNewspapersSearchBar} from './newspapersSearchBar/newspapersSearchBar.directive';
import {NewspapersService} from './newspapers.service';
import {PrmNewspapersSpotlight} from './newspapersSpotlight/newspapersSpotlight.directive';
import {PrmNewspapersFacet} from './newspapersFacet/newspapersFacet.directive';
import {PrmBackToLibrarySearch} from './backToLibrarySearch.directive';
import {PrmNewspapersFullView} from './newspapersFullView/newspapersFullView.directive';
import {PrmSearchResultTitle} from './searchResultTitle/searchResultTitle.directive';

@NgModule({
    declarations: [
        PrmNewspapersHome,
        PrmNewspapersSearchBar,
        PrmNewspapersFacet,
        PrmNewspapersSpotlight,
        PrmBackToLibrarySearch,
        PrmNewspapersFullView,
        PrmSearchResultTitle
    ],
    providers: [
        NewspapersService
    ],
    imports: []
})

export class NewspapersModule {
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/newspapers/newspapers.module.ts